import { ContactHandler } from "@type/core/contact/contact.types";
import { useUnit } from "effector-react/compat";
import { contactStore } from "@state/contact/ContactsStore";

export const useContacts = (): ContactHandler => {
  const contactHandler = useUnit<ContactHandler>(contactStore);

  return {
    contactForm: contactHandler.contactForm,
  };
};
